import { useState } from "react"
import { useDispatch } from "react-redux"

import Button from "../../../../../common/Button"
import { caseActions } from "../../../../../../store/case"
import CopyTextInhanced from "../../../../../fragments/CopyTextInhanced"
import { formatDateLocal, isDateInThePast } from "../../../../../../lib/script"
import { getShareableLinkForDocs } from "../../../../../../lib/fetchApi"
import { documentHasFileId } from "../../../../../../lib/docs"
import { notificationActions } from "../../../../../../store/notifications"

import classes from './Controls.module.css'
import { filterActions } from "../../../../../../store/filter"
import BodySimpleModalV3 from "../../../../../common/modal/BodySimpleModalV3"

export default function ShareLinkDocument({userToken, activeCase, item, isNormalDoc, docType, forRecords, practiceItem, forWorkQ}) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    if (!documentHasFileId(item)) {
        return null
    }

    async function generateNewShareableLinkHandler() {
        setLoading(true)
        try {
            let update = await getShareableLinkForDocs(userToken, activeCase.case.id, docType, item.id)
            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))            
            } else {       
                
                if (!forWorkQ) {
                    // add item to store dispatch
                    if (!isNormalDoc) {
                        dispatch(caseActions.replaceItemInProcoDocuments(update))
                    } else {
                        dispatch(caseActions.replaceWholeItemInDocuments(update))
                    }

                    if (forRecords) {
                        dispatch(caseActions.replaceDocumentInPractices({
                            case_practice_id: practiceItem.id,
                            newDoc: update
                        }))
                    }
                } else {
                    dispatch(filterActions.replaceDocumentInPractices({
                        case_id: activeCase.case.id,
                        case_practice_id: practiceItem.id,
                        newDoc: update
                    }))
                }
                
                
            }
        } finally {
            setLoading(false)
        }
    }

    const modalHtml = <>
        {!item.share_link && <Button btnStyle={'btn_text'} click={generateNewShareableLinkHandler} isLoading={loading} loaderType={'dark'}>Generate a new shareable link</Button>}         
        {item.share_link && <div>
            <CopyTextInhanced text={item.share_link} reversed={true} maxWidth={true} isLink={true}/>   
            <CopyTextInhanced text={item.share_password} reversed={true} maxWidth={true}/> 
            <div>{isDateInThePast(item.share_expiry) ? <div className={`${classes.expires_on} ${classes.expires_on_red}`}>
                Expired. <Button btnStyle={'btn_text'} color={'danger'} click={generateNewShareableLinkHandler} isLoading={loading} loaderType={'dark'} title={'generate a new link'}>Generate a new one</Button>
            </div>
            :
            <div className={classes.expires_on}>
                Expires on {formatDateLocal(item.share_expiry)}
            </div>}</div>
        </div>}  
    </>

    return <BodySimpleModalV3 message={modalHtml}>
        <i className="ti ti-share"></i>
    </BodySimpleModalV3>   

}